/**
 * Read the verdict of the minimum-browser gate.
 *
 * The gate itself runs in a classic inline script in index.html (and the partner
 * portal's) long before this module is parsed — it has to, because it must work
 * on browsers that cannot necessarily run the bundle at all. All this does is
 * read the flag that stub leaves behind.
 *
 * Both app entries check it before mounting. Without that, React would render a
 * full app underneath the interstitial: the user would see a blocking screen,
 * and the app behind it would still be running and still be broken.
 */
declare global {
	interface Window {
		__ONEAI_UNSUPPORTED_BROWSER__?: boolean;
	}
}

/** True when the browser is under the floor and the interstitial is showing. */
export function isUnsupportedBrowser(): boolean {
	return window.__ONEAI_UNSUPPORTED_BROWSER__ === true;
}
